module.exports = __webpack_public_path__ + "media/images/faces/male/43-cf14288610c64d7607c980be741f38e9.jpg";